<p-toast [breakpoints]="{ '765px': { width: '100%', right: '0', left: '0' } }"></p-toast>

@if (showMaintenance()) {
  <div class="flex items-center justify-center h-screen">
    <p-card class="w-full max-w-2xl mx-5">
      <div class="flex flex-col items-center text-center space-y-4">
        <img [src]="'assets/logo/' + theme() + '/logo.svg'" class="h-full max-h-10 mb-5" draggable="false" alt="Logo TOTEiM">
        <span class="text-2xl font-comfortaa font-semibold" translate="maintenance.title"></span>
        <span class="text-lg">{{ maintenanceMessage() }}</span>
      </div>
    </p-card>
  </div>
}
@else if (!networkStatus()) {
  <div class="flex items-center justify-center h-screen">
    <p-card class="w-full max-w-2xl mx-5">
      <div class="flex flex-col items-center text-center space-y-4">
        <span class="text-2xl font-comfortaa font-semibold" translate="offline.offline-title"></span>
        <span class="text-lg" translate="offline.offline-text"></span>
      </div>
    </p-card>
  </div>
}
@else {
  <router-outlet></router-outlet>
}
